import { render, staticRenderFns } from "./EditReceipt.vue?vue&type=template&id=6897ca7e&scoped=true"
import script from "./EditReceipt.vue?vue&type=script&lang=js"
export * from "./EditReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6897ca7e",
  null
  
)

export default component.exports